const ClothesRecognitionIcon = ({ className }: { className?: string }) => {
  return (
    <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 401 401" width="401" height="401" className={className}>
      <title>178693566_925f594e-c5d7-4162-ba44-5a75580d1f06</title>
      <style
        dangerouslySetInnerHTML={{
          __html: `
		.s0 { fill: currentColor } 
	`,
        }}
      />
      <g>
        <path
          className="s0"
          d="m125.3 232.1q-0.1 0-0.1 0c-1.8 0-3.2-1.6-3.2-3.4l2.1-53.1c-46.3 2.7-59.2-13.7-59.8-14.4-1.1-1.4-0.8-3.5 0.7-4.6 1.4-1.1 3.4-0.8 4.5 0.6 0.2 0.3 12.8 15.1 57.8 11.6 0.9 0 1.8 0.3 2.5 0.9 0.7 0.7 1 1.6 1 2.5l-2.2 56.8c-0.1 1.7-1.5 3.1-3.3 3.1z"
        />
        <path
          className="s0"
          d="m274.7 232.1c-1.8 0-3.2-1.4-3.3-3.1l-2.2-56.8c0-0.9 0.3-1.8 1-2.5 0.7-0.6 1.6-0.9 2.5-0.9 45 3.5 57.7-11.4 57.8-11.5 1.1-1.5 3.1-1.8 4.6-0.7 1.4 1.1 1.7 3.2 0.6 4.6-0.5 0.7-11.7 14.7-49.9 14.7q-4.7 0-9.9-0.3l2.1 53.1c0 1.8-1.4 3.4-3.2 3.4q-0.1 0-0.1 0z"
        />
        <path
          className="s0"
          d="m278.7 334.7h-157.4c-0.9 0-1.8-0.4-2.4-1-0.6-0.7-0.9-1.5-0.9-2.4l2.1-53.3c0.1-1.8 1.6-3.2 3.4-3.1 1.8 0 3.2 1.5 3.1 3.3l-1.9 49.9h150.6l-1.9-49.9c-0.1-1.8 1.3-3.3 3.1-3.3 1.8-0.1 3.3 1.3 3.4 3.1l2.1 53.3c0.1 0.9-0.3 1.7-0.9 2.4-0.6 0.6-1.5 1-2.4 1z"
        />
        <path className="s0" d="m278 313.9h-156c-1.8 0-3.3-1.5-3.3-3.3 0-1.8 1.5-3.3 3.3-3.3h156c1.8 0 3.3 1.5 3.3 3.3 0 1.8-1.5 3.3-3.3 3.3z" />
        <path
          className="s0"
          d="m287.2 193.9c-4.7 0-9.5-0.3-14.5-1.1-1.8-0.3-3-2-2.7-3.7 0.2-1.8 1.9-3 3.7-2.8 28.9 4.5 54.7-7.1 62.6-11.2l-32.8-76.7c-1.5-3.6-4.6-6.5-8.4-7.8l-51.8-17.5c-2.2 21.9-20.8 39-43.3 39-22.5 0-41.1-17.1-43.3-39l-51.8 17.5c-3.8 1.3-6.9 4.2-8.4 7.8l-32.9 76.9c6.6 4 28.3 15 62.8 11 1.8-0.2 3.5 1.1 3.7 2.9 0.2 1.8-1.1 3.4-2.9 3.6-44.4 5.2-68.6-12.9-69.6-13.7-1.2-0.9-1.7-2.5-1.1-3.9l34-79.3c2.3-5.4 6.7-9.6 12.3-11.4l55.9-19c1-0.3 2.1-0.2 2.9 0.4 0.9 0.7 1.4 1.6 1.4 2.7 0 20.4 16.6 37 37 37 20.4 0 37-16.5 37-36.9q0-0.6 0.2-1.2c0.6-1.7 2.4-2.6 4.1-2l55.9 19c5.5 1.8 10 6 12.3 11.4l34 79.4c0.6 1.5 0 3.2-1.4 4-1.1 0.7-24.6 14.6-54.9 14.6z"
        />
        <path
          className="s0"
          d="m200 129.5c-15.2 0-29.8-5.6-41-15.8-11.2-10.2-18.1-24-19.6-39-0.2-1.8 1.1-3.4 2.9-3.6 1.8-0.1 3.4 1.2 3.6 3 2.8 27.9 26 48.9 54.1 48.9 28.1 0 51.4-21 54.1-48.9 0.2-1.8 1.8-3.1 3.6-3 1.8 0.2 3.1 1.8 2.9 3.6-1.5 15-8.4 28.8-19.6 39-11.2 10.2-25.8 15.8-41 15.8z"
        />
        <g>
          <path
            className="s0"
            d="m297.9 281.4h-195.8c-4.4 0-7.9-3.5-7.9-7.9v-40c0-4.4 3.5-7.9 7.9-7.9h195.9c4.3 0 7.8 3.5 7.8 7.9v40c0 4.4-3.5 7.9-7.8 7.9zm-195.9-49.3c-0.8 0-1.4 0.6-1.4 1.4v40c0 0.8 0.6 1.4 1.4 1.4h195.9c0.7 0 1.3-0.6 1.3-1.4v-40c0-0.8-0.6-1.4-1.3-1.4z"
          />
          <g>
            <path className="s0" d="m280.6 249.9c-1.8 0-3.3-1.5-3.3-3.3v-17.7c0-1.8 1.5-3.3 3.3-3.3 1.8 0 3.3 1.4 3.3 3.3v17.7c0 1.8-1.5 3.3-3.3 3.3z" />
            <path className="s0" d="m262.7 256.8c-1.8-0.1-3.3-1.5-3.3-3.3v-24.6c0-1.8 1.5-3.3 3.3-3.3 1.8 0 3.3 1.4 3.3 3.3v24.6c0 1.8-1.5 3.2-3.3 3.2z" />
            <path className="s0" d="m244.8 249.9c-1.8 0-3.3-1.5-3.3-3.3v-17.7c0-1.8 1.5-3.3 3.3-3.3 1.8 0 3.3 1.4 3.3 3.3v17.7c0 1.8-1.5 3.3-3.3 3.3z" />
            <path className="s0" d="m226.9 256.8c-1.8-0.1-3.3-1.5-3.3-3.3v-24.6c0-1.8 1.5-3.3 3.3-3.3 1.8 0 3.2 1.4 3.2 3.3v24.6c0 1.8-1.4 3.2-3.2 3.2z" />
            <path className="s0" d="m209 249.9c-1.8 0-3.3-1.5-3.3-3.3v-17.7c0-1.8 1.4-3.3 3.3-3.3 1.8 0 3.2 1.4 3.2 3.3v17.7c0 1.8-1.4 3.3-3.2 3.3z" />
            <path className="s0" d="m191 256.8c-1.8-0.1-3.2-1.5-3.2-3.3v-24.6c0-1.8 1.4-3.3 3.2-3.3 1.8 0 3.3 1.4 3.3 3.3v24.6c0 1.8-1.5 3.2-3.3 3.2z" />
            <path className="s0" d="m173.1 249.9c-1.8 0-3.2-1.5-3.2-3.3v-17.7c0-1.8 1.4-3.3 3.2-3.3 1.8 0 3.3 1.4 3.3 3.3v17.7c0 1.8-1.5 3.3-3.3 3.3z" />
            <path className="s0" d="m155.2 256.8c-1.8-0.1-3.3-1.5-3.3-3.3v-24.6c0-1.8 1.5-3.3 3.3-3.3 1.8 0 3.3 1.4 3.3 3.3v24.6c0 1.8-1.5 3.2-3.3 3.2z" />
            <path className="s0" d="m137.3 249.9c-1.8 0-3.3-1.5-3.3-3.3v-17.7c0-1.8 1.5-3.3 3.3-3.3 1.8 0 3.3 1.4 3.3 3.3v17.7c0 1.8-1.5 3.3-3.3 3.3z" />
            <path className="s0" d="m119.4 256.8c-1.8-0.1-3.3-1.5-3.3-3.3v-24.6c0-1.8 1.5-3.3 3.3-3.3 1.8 0 3.2 1.4 3.2 3.3v24.6c0 1.8-1.4 3.2-3.2 3.2z" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default ClothesRecognitionIcon;
